module.exports = __webpack_public_path__ + "static/media/build-your-own-collection-desktop.f69a24f2.svg";